import { useEffect, useState } from "react";

export const useAutarkyLineWidth = (
    autarkyDataLength: number,
    stackedBarGroupWidth: number,
    stackedBarTotalWidth: number,
    upTabletView: boolean,
): number => {
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        if (autarkyDataLength === 0) {
            setWidth(0);
        } else {
            if (upTabletView) {
                const subtractWidth = (stackedBarTotalWidth - autarkyDataLength * stackedBarGroupWidth) / autarkyDataLength;
                setWidth(stackedBarTotalWidth - subtractWidth - stackedBarGroupWidth);
            } else {
                setWidth(stackedBarTotalWidth - stackedBarGroupWidth);
            }
        }
    }, [autarkyDataLength, stackedBarTotalWidth, stackedBarGroupWidth, upTabletView]);

    return width;
};
